import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import SelectBox from '@adsk/alloy-select-box';
import FormField from '@adsk/alloy-react-form-field';
import { COMPONENT_VARIANTS } from '@common/constants';
import { useStore } from '../../../StoreProvider';
import { fieldStyle } from '../../styles';
import { ACTIONS } from '../../state/actions';
import Label from '../../../Label';

const RoleField = ({ roles, onChangeRoleInput, variant }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { state, dispatch } = useStore();

  const handleRoleChange = (value) => {
    dispatch({
      type: ACTIONS.SET_ROLE,
      payload: value,
    });
  };

  const handleRoleInputChange = (value) => {
    dispatch({
      type: ACTIONS.SET_ROLE_SEARCH_INPUT,
      payload: value,
    });
  };

  const latestOnChangeRoleInput = useRef(onChangeRoleInput);

  useEffect(() => {
    latestOnChangeRoleInput.current = onChangeRoleInput;
  }, [onChangeRoleInput]);

  useEffect(() => {
    if (!latestOnChangeRoleInput.current) return;

    const handler = setTimeout(() => {
      latestOnChangeRoleInput.current(state.roleSearchInput.trim());
    }, 800);

    return () => clearTimeout(handler);
  }, [state.roleSearchInput]);

  const label =
    variant !== COMPONENT_VARIANTS.PROJECT ? (
      T.translate('ACCOUNT_ROLE_LABEL')
    ) : (
      <Label
        required
        text={T.translate('ROLE_LABEL')}
        tooltipMessage={T.translate('ROLE_LABEL_INFO')}
        size={13}
        labelStyle={{ paddingBottom: '0px' }}
      />
    );

  return (
    <FormField
      label={label}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
      style={fieldStyle}
      data-testid="InviteProjectMemberModal_role_field"
    >
      <SelectBox
        clearable={variant !== COMPONENT_VARIANTS.PROJECT}
        ignoreCase
        labelKey="name"
        subtextKey={variant === COMPONENT_VARIANTS.PROJECT && 'description'}
        maxMenuHeight={200}
        onChange={handleRoleChange}
        onInputChange={handleRoleInputChange}
        options={roles}
        placeholder={T.translate('ROLE_PLACEHOLDER')}
        searchable
        value={state.selectedRole}
        valueKey="id"
      />
    </FormField>
  );
};

RoleField.propTypes = {
  roles: PropTypes.array,
  onChangeRoleInput: PropTypes.func,
  variant: PropTypes.oneOf(Object.values(COMPONENT_VARIANTS)),
};

export default RoleField;
